<template>
  <v-row class="pt-16 px-6 ma-0">
    <seo-v-img :src="require('../assets/img/header-background.jpg').default" :aspect-ratio="3589/1334" class="mx-n6" width="100%" :max-width="$vuetify.breakpoint.mdAndUp ? '80%' : '100%'" contain>
      <v-row align="center" class="fill-height" no-gutters>
        <v-col cols="12" class="text-h4 text-md-h1 text-uppercase pa-8 pa-md-16 font-family-heading text-center">Workshops &amp; More</v-col>
      </v-row>
    </seo-v-img>
    <v-col cols="12" md="11" class="mx-md-auto">
      <v-row align="center" justify="center" v-if="!Workshops" key="loading">
        <v-col cols="auto">
          <v-progress-circular indeterminate />
        </v-col>
      </v-row>
      <v-row v-else v-for="workshop in Workshops.items" :key="workshop.id" justify="center">
        <WorkshopBigCard :list-data="workshop" class="col col-12 col-md-10 my-8" />
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import ListWorkshop from '@/graphql/ListWorkshop.gql'
import WorkshopBigCard from '@/molecules/WorkshopBigCard.vue'

export default {
  name: 'WorkshopListPage',
  components: {
    WorkshopBigCard
  },
  computed: {
  },

  methods: {
  },

  apollo: {
    Workshops: {
      query: ListWorkshop,
      // skip: true,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'startingAt',
          descending: false
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  }
}
</script>
